import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import i18n from "../../i18n";
import DateFilter from "../ui/DateFilter";
import LoadingSpinner from "../Loading";

import InventoryWiseTable from "./Tables/InventoryWiseTable";
import GroupWiseTable from "./Tables/GroupWiseTable";
import CategoryWiseTable from "./Tables/CategoryWiseTable";

import InventorySaleSummaryTable from "../../app/inventory/InventorySaleSummary/InventorySaleSummartTable";
import InventorySaleReport from "./InventorySaleReport";
import CategoryWiseReport from "./CategoryWiseReport";
import GroupSaleReport from "./GroupSaleReport";

const CashierSalesReports = () => {
    const { t } = useTranslation();

    const [selected, setSelected] = useState("Inventory Wise");
    const [loading, setLoading] = useState(false);

    const handleToggle = (_, value) => {
        if (value) {
            setSelected(value);
        }
    };

    return (
        <div className="w-full flex flex-col pb-6 overflow-y-auto bg-[#F6F7F9] min-h-screen">
            <Navbar heading={t("Cashier Sales Reports")} />

            <div className="px-6 py-6">

                {/* Toggle */}
                <div className="flex justify-center w-full px-4 mt-4 gap-4 items-center mb-4">
                    <ToggleButtonGroup
                        value={selected}
                        exclusive
                        onChange={handleToggle}
                        sx={{
                            borderRadius: "9999px",       // Rounded pill shape
                            p: "4px",
                            backgroundColor: "#fff",
                            border: "1px solid #cbd5e1",  // Border around the whole group
                            "& .MuiToggleButton-root": {
                                border: "none",              // Remove individual button borders
                                borderRadius: "9999px",
                                padding: "6px 24px",
                                color: "#6b7280",
                                fontSize: "0.875rem",
                                fontWeight: 500,
                                textTransform: "none",
                                marginRight: "8px",          // Spacing between buttons
                                "&:last-of-type": {
                                    marginRight: 0,            // No extra margin for last button
                                },
                            },
                            "& .Mui-selected": {
                                backgroundColor: "#38bdf8 !important",
                                color: "#fff !important",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                            },

                        }}
                    >
                        <ToggleButton value="Inventory Wise">{t("Inventory Wise Sale")}</ToggleButton>
                        <ToggleButton value="Group Wise">{t("Group Wise Sale")}</ToggleButton>
                        <ToggleButton value="Category Wise">{t("Category Wise Sale")}</ToggleButton>
                    </ToggleButtonGroup>
                </div>


                {/* Loader */}
                {loading ? (
                    <div className="flex justify-center py-10">
                        <LoadingSpinner />
                    </div>
                ) : (
                    <>
                        {selected === "Inventory Wise" && (

                            <InventorySaleReport
                            />
                        )}

                        {selected === "Group Wise" && (
                            <GroupSaleReport
                            />
                        )}

                        {selected === "Category Wise" && (
                            <CategoryWiseReport />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default CashierSalesReports;
